var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 86,
    viewBox: "0 0 67 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3657_16833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2843 80.7661L18.4022 77.0313C22.6639 77.1703 26.3561 76.9518 29.3806 76.3955L30.0385 80.0708C26.7588 80.6767 22.8014 80.9051 18.2843 80.7661ZM36.0384 79.2662L35.0957 75.6506C37.0007 75.144 38.4442 74.2798 39.4066 73.0779C40.202 72.0846 40.7126 70.7933 40.9188 69.2438L44.5816 69.7504C44.2772 71.9853 43.5014 73.8924 42.2739 75.4221C40.8108 77.2597 38.7094 78.551 36.0384 79.2662ZM39.2887 63.9892C38.5621 63.1052 37.7176 62.1814 36.7847 61.2477C34.6636 59.1419 32.9255 57.1454 31.6097 55.3177L34.6047 53.1225C35.7929 54.7813 37.3935 56.6189 39.3673 58.5757C40.3984 59.5988 41.3312 60.6219 42.1365 61.6053L39.2887 63.9892ZM28.5165 48.891C28.3005 47.7984 28.2808 46.7455 28.4576 45.7621C29.0468 42.524 31.6784 40.1699 36.2741 38.7693L37.3346 42.3452C34.1727 43.3087 32.4051 44.6894 32.0909 46.4376C32.0025 46.9442 32.0123 47.5203 32.14 48.1461L28.5165 48.891ZM43.2166 41.2327L42.8337 37.5177C46.1822 37.1602 50.1003 37.0708 54.4995 37.2496L54.3522 40.9844C50.1297 40.8155 46.3884 40.895 43.2166 41.2327Z",
    fill: "#09314C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 13.2407C67 20.5514 61.4715 30.7526 53.9103 33.5438C46.9285 31.0407 40.8206 20.5514 40.8206 13.2407C40.8206 5.93001 46.683 0 53.9103 0C61.1376 0 67 5.93001 67 13.2407Z",
    fill: "#AACA11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9103 21.6345C57.7662 21.6345 60.8921 18.4726 60.8921 14.5721C60.8921 10.6717 57.7662 7.50977 53.9103 7.50977C50.0543 7.50977 46.9285 10.6717 46.9285 14.5721C46.9285 18.4726 50.0543 21.6345 53.9103 21.6345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60654 74.1055L12.5957 82.641",
    stroke: "#09314C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6757 74.1895L4.52702 82.558",
    stroke: "#09314C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3657_16833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.dfcab0b8e8d1ef4e46b1134ea1e2aed4.svg";
export { ForwardRef as ReactComponent };